
export class AtRiskReasonConfigModel implements IAtRiskReasonConfigModel {
  title?: string | undefined;
  variable?: string | undefined;

  constructor(data?: IAtRiskReasonConfigModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(Data?: any) {
    if (Data) {
      this.title = Data["title"];
      this.variable = Data["variable"];
    }
  }

  static fromJS(data: any): AtRiskReasonConfigModel {
    data = typeof data === 'object' ? data : {};
    let result = new AtRiskReasonConfigModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["title"] = this.title;
    data["variable"] = this.variable;
    return data;
  }
}

export interface IAtRiskReasonConfigModel {
  title?: string | undefined;
  variable?: string | undefined;
}
